import * as React from 'react'
import './spinner.css'

class Spinner extends React.Component {
  render() {
    return (
      <div className="spinner-box">
        <div className="loading-icon"></div>
        <span>Loading...</span>
      </div>
    )
  }
}

export default Spinner
